<template>
  <div class="app-container">
    <div class="order-title">
      <i class="title-icon"></i>
      <span class="title-span">确认订单</span>
    </div>
    <div class="order-info-container" v-for="(item,index) in formData" :key="item.stageName">
      <div class="order-items">
        <div class="order-item">
          <span class="item-left">课期</span>
          <div class="item-right" >{{item.stageName}}</div>
        </div>
        <div class="order-item">
          <span class="item-left">主讲老师</span>
          <span class="item-right">{{item.teacherName}}</span>
        </div>
        <div class="order-item">
          <span class="item-left">开课日期</span>
          <span class="item-right">{{item.firstClassDate}}</span>
        </div>
        <div class="order-item">
          <span class="item-left">上课时间</span>
          <span class="item-right">{{item.timeRange +' ' + '(' + item.frequency + ')'}}</span>
        </div>
      </div>
      <img v-if="item.coupons && item.coupons.length > 0" class="order-line" :src="orderLine" />
      <div v-if="item.coupons && item.coupons.length > 0" class="coupon-item">
        <i class="coupon-title"></i>
        <span class="coupon-item-left">优惠券</span>
        <div class="coupon-list">
          <div class="coupon-item-right" v-for="(coupon,i) in item.coupons" :key="coupon.couponCode">
            <span :class="`coupon-item-title-checked-${coupon.selectStatus === null?0:coupon.selectStatus}`">{{coupon.couponName}}</span>
            <button :class="`coupon-item-checked-${coupon.selectStatus === null?0:coupon.selectStatus}`" @click="onClickCoupon(index,i)"/>
          </div>
        </div>
      </div>
    </div>
    <div class="order-price-container">
      <div class="order-items">
        <span class="item-left">商品金额</span>
        <div class="original-price">
          <span class="price-sign">¥</span>
          <span class="price">{{originTotalPrice.toFixed(2)}}</span>
        </div>
      </div>
    </div>
    <div class="seize-seat-container"/>
    <div class="footer">
      <div class="footer-price">
        <span style='font-size: 12px; font-weight: 600;color: #FE6522;line-height: 36px;'>¥</span>
        <span class="last-price">{{targetTotalPrice.toFixed(2)}}</span>
      </div>
      <button :disabled="disabled" @click="createdOrder">提交订单</button>
    </div>
    <van-overlay :show="disabled">
      <van-loading class="loading" type="spinner" color="#1989fa" vertical>加载中...</van-loading>
    </van-overlay>
  </div>
</template>

<script>
import { getOrderInfo, trialOrderPrice, createCombinationOrder } from '@/api/conference-qrcode'
import { recordStudentActivation } from '@/api/landingpage'
import orderBg from '@/assets/img/conference-qrcode/order-bg.png'
import orderTitle from '@/assets/img/conference-qrcode/order-title.png'
import orderLine from '@/assets/img/conference-qrcode/order-line.png'
import { ACTIVITYCODE, CHANNELID, ORDERLIST } from '@/config/conferenceqrcode.js'
import cookie from 'js-cookie'
import sasdk from './sasdkinit'
const parentId = cookie.get('mbparentid')
export default {
  data () {
    return {
      orderBg,
      orderTitle,
      orderLine,
      disabled: false,
      formData: [{}],
      targetTotalPrice: 0,
      originTotalPrice: 0
    }
  },
  created () {
    const parentId = cookie.get('mbparentid')
    if (parentId) {
      sasdk.confirmorderpage()
      getOrderInfo(this.$route.query.studentId).then(res => {
        if (res.data) {
          this.formData = res.data.goodsInfoList
          this.originTotalPrice = res.data.originTotalPrice
          this.targetTotalPrice = res.data.targetTotalPrice
        } else {
          this.$router.push({
            name: 'acTouch',
            query: {
              channelId: CHANNELID,
              activityCode: ACTIVITYCODE
            }
          })
        }
      })
    } else {
      this.$router.push({
        name: 'change-child'
      })
    }
  },
  methods: {
    createdOrder () {
      this.disabled = true
      sasdk.createorder()
      recordStudentActivation({
        activityCode: ACTIVITYCODE,
        channelId: CHANNELID,
        parentId: parentId,
        studentId: this.$route.query.studentId
      })
      createCombinationOrder({
        parentId: parentId,
        studentId: this.$route.query.studentId,
        stageGoodsList: this.getCouponInfo() ? this.getCouponInfo() : null
      }).then(res => {
        this.disabled = false
        if (res.code === 200 || res.code === 1000019) {
          window.location.href = ORDERLIST
        } else {
          this.$router.push({
            name: 'conferenceQRCode-error'
          })
        }
      })
    },
    getCouponInfo () {
      return this.formData.map((item) => {
        let couponCode = ''
        if (item.coupons) {
          for (let i = 0; i < item.coupons.length; i++) {
            if (item.coupons[i].selectStatus === 1) {
              couponCode = item.coupons[i].couponCode
            }
          }
        }
        return {
          couponCode: couponCode,
          stageId: item.stageId
        }
      })
    },
    onClickCoupon (index, i) {
      let coupon = this.formData[index].coupons[i]
      if (coupon.selectStatus === 2) {
        return
      }
      if (coupon.selectStatus === 1) {
        coupon.selectStatus = 0
      } else {
        this.formData[index].coupons.forEach(e => {
          e.selectStatus = 0
        })
        coupon.selectStatus = 1
      }
      trialOrderPrice({
        parentId: parentId,
        studentId: this.$route.query.studentId,
        stageGoodsList: this.getCouponInfo()
      }).then(res => {
        this.formData = res.data.goodsInfoList
        this.originTotalPrice = res.data.originTotalPrice
        this.targetTotalPrice = res.data.targetTotalPrice
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.app-container {
  min-height: 100vh;
  overflow: hidden;
  position:relative;
  box-sizing: border-box;
  padding-bottom: 128px;
  padding: 80px 32px 32px 32px;
  background: url("~@/assets/img/conference-qrcode/order-bg.png") #f8f8f8 no-repeat;
  background-size: 100% 596px;
}
.order-items {
  background: #ffffff;
  border-radius: 16px 16px 0px 0px;
  padding: 32px 32px 32px 16px;
}
.order-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 32px;
  background: #ffffff;
}
.coupon-item {
  display: flex;
  justify-content: space-between;
  padding: 18px 32px 0px 30px;
  background: #ffffff;
}
.coupon-item-left {
  font-size: 28px;
  font-weight: 400;
  text-align: left;
  color: #9199a3;
  line-height: 40px;
}
.coupon-item-right {
  font-size: 28px;
  font-weight: 400;
  text-align: left;
  color: #9199a3;
  margin-bottom: 32px;
  line-height: 40px;
}
.item-left,.item-right {
  font-size: 28px;
  font-weight: 400;
  text-align: left;
  color: #9199a3;
  line-height: 40px;
}
.item-right {
  color: #2f3338;
  line-height: 40px;
  max-width: 392px;
  max-height: 80px;
  overflow:hidden;
  text-overflow:ellipsis;
  display:-webkit-box;
  -webkit-box-orient:vertical;
  -webkit-line-clamp:2;
}
.order-line {
  width: 100%;
  height: 32px;
}
.order-title {
  line-height: 60px;
  display: flex;
  align-items: center;
  margin-left: 8px;
}
.title-icon {
  width: 36px;
  height: 46px;
  background: url("~@/assets/img/conference-qrcode/order-title.png") no-repeat;
  background-size: 36px 46px;
}
.title-span {
  height: 60px;
  font-size: 44px;
  font-weight: 600;
  text-align: left;
  color: #ffffff;
  line-height: 60px;
  margin-left: 8px;
}
.original-price{
  height: 40px;
  font-size: 24px;
  font-weight: 500;
  text-align: right;
  color: #2f3338;
  line-height: 34px;
  display:inline;
  float: right;
}
.van-radio--horizontal {
  margin-right:0px;
}
.order-info-container {
  margin-top: 32px;
}
.coupon-title {
  width: 32px;
  height: 32px;
  background: url("~@/assets/img/conference-qrcode/coupon-title.png") no-repeat;
  background-size: 32px 32px;
  margin-right:8px;
  margin-top: 2px;
}
.coupon-list {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.coupon-item-title {
  height: 40px;
  font-size: 28px;
  font-weight: 400;
  text-align: left;
  color: #2F3338;
  line-height: 40px;
}
.coupon-item-title-checked-1,.coupon-item-title-checked-2,.coupon-item-title-checked-0 {
  line-height: 40px;
  vertical-align:middle;
}
.coupon-item-title-checked-1 {
  color: #FF6422;
}
.coupon-item-title-checked-2 {
  color: #c7d1dd;
}
.coupon-item-title-checked-0 {
  color: #2F3338;
}
.coupon-item-checked-0,.coupon-item-checked-2 {
  width: 40px;
  height: 40px;
  margin-left: 16px;
  background: url("~@/assets/img/conference-qrcode/coupon-unchecked.png") no-repeat;
  background-size: 40px 40px;
}
.coupon-item-checked-1 {
  width: 40px;
  height: 40px;
  margin-left: 16px;
  background: url("~@/assets/img/conference-qrcode/coupon-checked.png") no-repeat;
  background-size: 40px 40px;
}
.coupon-item-unchecked {
  background: url("~@/assets/img/conference-qrcode/coupon-unchecked.png") no-repeat;
  background-size: 40px 40px;
}
.order-price-container {
  width: 100%;
  height: 104px;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0px 2px 14px 0px rgba(229,229,229,0.08);
  margin-top: 32px;
}
.price-sign {
  font-size: 24px;
  line-height: 34px;
  color: #2F3338;
  font-weight: 400;
}
.footer {
  position: fixed;
  left: 0px;
  bottom: 0px;
  width: 100%;
  height: 188px;
  background-color: #FFFFFF;
  z-index: 9999;
  .footer-price {
    float: left;
    margin: 36px 0 0 32px;
    height: 48px;
    font-size: 32px;
    font-weight: 600;
    text-align: left;
    color: #ff6422;
    line-height: 48px;
  }
  .last-price {
    height: 48px;
    opacity: 1;
    font-size: 48px;
    font-weight: 600;
    text-align: left;
    color: #ff6422;
    line-height: 48px;
  }
  button {
    width: 200px;
    height: 80px;
    background: #FE6522;
    border-radius: 40px;
    font-size: 28px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 36px;
    text-align: center;
    margin: 20px 32px 0 0;
    display: inline;
    float: right;
  }
}
.seize-seat-container {
  width: 100%;
  height: 188px;
}
.price {
  height: 40px;
  font-size: 30px;
  font-weight: 500;
  text-align: right;
  color: #2f3338;
  line-height: 34px;
}
.loading {
  text-align: center;
  margin-top: 500px;
}
</style>
